import { createBrowserRouter } from "react-router-dom";

import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import SignUp from "./pages/SignUp";
// import Dashboard from "./pages/Dashboard";
import Students from "./pages/Students";
import StudentsDetails from "./pages/StudentsDetails";
import Professors from "./pages/Professors";
import Menu from "./components/Menu";
import Classes from "./pages/Classes";
import Policy from "./pages/Policy";
import Terms from "./pages/Terms";
import Contract from "./pages/Contract";
import Spaces from "./pages/Spaces";
import Modality from "./pages/Modality";
import Plans from "./pages/Plans";
import Admins from "./pages/Admins";
import Reports from "./pages/Reports";
import MyGym from "./pages/MyGym";
import Class from "./pages/Class";
import MyUser from "./pages/MyUser";
import Coupons from "./pages/Coupons";
import ModalityDetails from "./pages/ModalityDetails";
import Checkout from "./pages/Checkout";
import AttendanceList from "./pages/AttendanceList";
import Finance from "./pages/Finance";
// import FinanceDetails from "./pages/FinanceDetails";
import Responsible from "./pages/Responsible";
import ResponsibleDetails from "./pages/ResponsibleDetails";
import ClassDetails from "./pages/ClassDetails";
import Marketplace from "./pages/Marketplace";
import ProductsDetails from "./pages/ProductsDetails";
import ProductsRegister from "./pages/ProductsRegister";
import ErrorPage from "./pages/ErrorPage";
import FreePeriodExpired from "./pages/FreePeriodExpired";
import ProfessorDetails from "./pages/ProfessorDetails";
import Gympass from "./pages/Gympass";
import Orders from "./pages/Orders";
import OrdersRegister from "./pages/OrdersRegister";
import OrdersDetails from "./pages/OrdersDetails";
import Branches from "./pages/Branches";
import PayableCounts from "./pages/PayableCounts";
import Visitors from "./pages/Visitors";

export const routers = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/signup",
    element: <SignUp />,
  },
  {
    path: "/free-period-expired",
    element: <FreePeriodExpired />,
  },
  {
    element: <Menu />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/dashboard",
        element: <Reports />,
      },
      {
        path: "/students",
        element: <Students />,
      },
      {
        path: "/professors",
        element: <Professors />,
      },
      {
        path: "/professors-details/:id",
        element: <ProfessorDetails />,
      },
      {
        path: "/students-details/:id",
        element: <StudentsDetails />,
      },
      {
        path: "/classes",
        element: <Classes />,
      },
      {
        path: "/attendance-list/:id",
        element: <AttendanceList />,
      },
      {
        path: "/class",
        element: <Class />,
      },
      {
        path: "/class/:id",
        element: <ClassDetails />,
      },

      {
        path: "/spaces",
        element: <Spaces />,
      },
      {
        path: "/modality",
        element: <Modality />,
      },
      {
        path: "/modality-details/:id",
        element: <ModalityDetails />,
      },
      {
        path: "/plans",
        element: <Plans />,
      },
      {
        path: "/admins",
        element: <Admins />,
      },
      {
        path: "/reports",
        element: <Reports />,
      },
      {
        path: "/coupons",
        element: <Coupons />,
      },
      {
        path: "/financeiro",
        element: <Finance />,
      },
      {
        path: "/payable-accounts",
        element: <PayableCounts />,
      },
      // {
      //   path: "/financeiro/:id",
      //   element: <FinanceDetails />,
      // },
      {
        path: "/my-gym",
        element: <MyGym />,
      },
      {
        path: "/my-user",
        element: <MyUser />,
      },
      {
        path: "/responsaveis",
        element: <Responsible />,
      },
      {
        path: "/responsaveis/:id",
        element: <ResponsibleDetails />,
      },
      {
        path: "/visitantes",
        element: <Visitors />,
      },

      {
        path: "/products",
        element: <Marketplace />,
      },
      {
        path: "/products/:id",
        element: <ProductsDetails />,
      },
      {
        path: "/products/register",
        element: <ProductsRegister />,
      },
      {
        path: "/orders",
        element: <Orders />,
      },
      {
        path: "/orders/register",
        element: <OrdersRegister />,
      },
      {
        path: "/orders/:id/details",
        element: <OrdersDetails />,
      },
      {
        path: "/gymapss",
        element: <Gympass />,
      },
      {
        path: "/branches",
        element: <Branches />,
      },
    ],
  },
  {
    path: "/politica-privacidade",
    element: <Policy />,
  },
  {
    path: "/termo-contrato",
    element: <Contract />,
  },
  {
    path: "/termos-condicoes",
    element: <Terms />,
  },
  {
    path: "/i/:webToken",
    element: <Checkout />,
  },
  {
    path: "*",
    element: <ErrorPage />,
  },
]);
